import React from 'react';
import { Spinner } from '@kui/foundations-react';
import { HorizontalLogo } from '@kui/foundations-react/Logo';
import '../styles/RegCard.css';
import '../styles/TenantPicker.css';

// Full-page loading state in the same card style as the TenantPicker ("Loading tenants").
const PageLoading = ({ message }) => (
  <div className="regPage regPage--narrow">
    <div className="login-container">
      <div className="regCard regCard--signin tenantCard">
        <div className="regHeaderLogo">
          <HorizontalLogo role="img" aria-label="NVIDIA" />
        </div>
        <div className="tenantCenter">
          <Spinner slotDescription={message} />
        </div>
      </div>
    </div>
  </div>
);

export default PageLoading;
